export const maskName = (name) => {
  if (!name) return "******";

  return name.length > 1 ? name[0].toUpperCase() + "******" : name;
};
